<template>
  <div class="radio-wrapper">

    <div class="radio"
         v-for="(item, index) in selectList"
         :key="index">

      <p class="title">{{ viewList[index] }}</p>

      <input class="checkbox" type="radio"
             :id="`${name}${index}`" :name="`${name}${index}`"
             :value="item"
             v-model="inputValue">

      <label :for="`${name}${index}`" class="checkbox-style"></label>

    </div>

  </div>
</template>

<script>
export default {
  name: 'LayoutRadioButton',
  props: {
    name: [String, Number],
    value: [String, Number],
    selectList: {
      type: Array,
      default: () => [],
    },
    viewList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  watch: {
    inputValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;


  input[type="radio"]+label {
    display: block;
    position: relative;
    top: 1px;

    width: 15px;
    height: 15px;

    box-sizing: border-box;
    margin-right: 30px;

    border: rgba(0, 0, 0, 0.2) 1px solid;
    border-radius: 10px;

    transition: all 0.2s ease-in-out;

    cursor: pointer;
  }

  input[type="radio"]:checked+label {
    background-color: #0fb8ad;
  }

  .radio {
    width: auto;
    height: auto;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;

    .title {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 10px;

      font-size: 14px;
      color: rgba(0, 0, 0, 0.8);
    }

    .checkbox {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutRadioButton.vue